import { RootState } from 'redux/reducers'
import { PageContentItem } from 'redux/reducers/pageContentReducer'

export const selectPageContent = (state: RootState, pageId: number): PageContentItem | undefined =>
  state?.pageContent[pageId]
